// extracted by mini-css-extract-plugin
export default {"switcher":"AWfWL0"};